import * as React from 'react';
import PropTypes from 'prop-types';

import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { Toolbar, Typography, TextField, Box } from '@mui/material';
import Container from './styles/Container';
import ErrorWrapper from './styles/ErrorWrapper';

export default function EnhancedTableToolbar({ allErrorsLength, onChangeSearchVehicle }) {
  const [searchValue, setSearchValue] = React.useState('');

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
    if (e.target.value.length > 2) onChangeSearchVehicle(e.target.value);
    else onChangeSearchVehicle('');
  };

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
      }}
    >
      <Container>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <Typography variant="subtitle1" id="tableTitle" component="div">
            Транспортные средства
          </Typography>
          <TextField
            variant="outlined"
            size="small"
            placeholder="Поиск"
            value={searchValue}
            onChange={handleSearchChange}
            sx={{ width: 240 }}
          />
        </Box>

        {allErrorsLength ? (
          <ErrorWrapper>
            <ReportProblemIcon sx={{ color: 'red' }} />
            <Typography variant="subtitle1" component="p" sx={{ color: 'red' }}>
              {allErrorsLength}{' '}
              {allErrorsLength === 0 ? 'Предупреждений' : allErrorsLength <= 4 ? 'Предупреждения' : 'Предупреждений'}
            </Typography>
          </ErrorWrapper>
        ) : null}
      </Container>
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  allErrorsLength: PropTypes.number.isRequired,
  onChangeSearchVehicle: PropTypes.func.isRequired,
};
